export const GLOBALS = {}

GLOBALS.WALLET_TYPE_COINBASE = 'walletLink'
GLOBALS.WALLET_TYPE_WALLETCONNECT = 'walletconnect'
GLOBALS.WALLET_TYPE_FORTMATIC = 'fortmatic'
GLOBALS.WALLET_TYPE_TORUS = 'torus'
GLOBALS.WALLET_TYPE_PORTIS = 'portis'
GLOBALS.WALLET_TYPE_UPORT = 'uport'
GLOBALS.WALLET_TYPE_AUTHEREUM = 'authereum'
GLOBALS.WALLET_TYPE_BITSKI = 'bitski'
GLOBALS.WALLET_TYPE_SQUARELINK = 'squarelink'
GLOBALS.WALLET_TYPE_ARKANE = 'arkane'
GLOBALS.WALLET_TYPE_METAMASK = 'metamask'
GLOBALS.WALLET_TYPE_NATIVE = 'native'
